/**
 * T-120: MotoWalla Pro is not commissioned and cannot be completed.
 *
 * All four placements (sidebar 'Go Pro', feed banner, persistent bottom toast,
 * and the /pro page) drive a CTA that fires POST /api/subscriptions/checkout
 * against our own API, which 500s. No payment provider is wired, so nobody can
 * be charged and nobody can subscribe. Decision 105: an option a user cannot
 * complete must not be RENDERED.
 *
 * WHY A FLAG AND NOT DELETION: the operator has not cancelled Pro, only failed
 * to commission it — the Rs149/mo tier is a product decision that is not mine
 * to make permanent. The endpoint stays, the UI darkens, no provider is wired.
 * Flipping this to true is the whole re-enable, so the work cannot be
 * half-restored across four files.
 *
 * WHEN THIS BECOMES TRUE: a real provider is wired AND checkout returns 200.
 * Not before — rendering the CTA is what created the dead end in the first
 * place.
 */
export const PRO_ENABLED = false;

/**
 * T-171 commit 2: the article-page monetization layer is DARK pending the
 * operator's sign-off.
 *
 * What this gates: the Insurance / CarLoan / DealerPrice partner components AND
 * the inline affiliate anchors in the same file (Check Best Price, Get
 * Insurance Quote). Both shapes, because gating only the components leaves the
 * raw <a> tags rendering and the page LOOKS purged while still routing readers
 * out — the same second-site shape as T-148's two unknown insert sites.
 *
 * WHY IT WAS PULLED (three independent reasons, all still true):
 *  1. It routes our readers to CarDekho, CarWale and ZigWheels — our DIRECT
 *     COMPETITORS.
 *  2. Every unit takes `vehicleName={post.brands?.[0] || post.title...}`, so
 *     when brands is empty the ARTICLE TITLE lands in the vehicle slot: the
 *     operator was shown 'Insure your One Owner Is Not the Selling Point You
 *     Think It Is'. The layer assumes article == vehicle, which is false on an
 *     article page and is why it can never be correct there.
 *  3. Not one unit carries an affiliate disclosure.
 *
 * WHY A FLAG AND NOT DELETION — the deliberate opposite of the SPONSORED unit
 * in commit 1. That unit fabricated a commercial relationship with a real
 * company, so it had no approved future and was deleted outright. This layer
 * HAS an approved future: it returns on Stive's sign-off with real
 * integrations, real disclosures, and VEHICLE-PAGE-ONLY targeting. Dark code
 * can be re-lit against a spec; deleted code has to be rebuilt.
 *
 * WHEN THIS BECOMES TRUE: all three of operator sign-off, a real disclosure on
 * every unit, and a render path that cannot put an article title in a vehicle
 * slot. Flipping this one boolean is the whole re-enable, so it cannot be
 * half-restored across call sites.
 */
export const ARTICLE_MONETIZATION_ENABLED = false;
